import styled from 'styled-components';

export const Wrapper = styled.section`
  .listings {
    min-height: 600px;
  }
`;
